import { Component } from "react";
import { connect } from "react-redux";
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { default as mainMenuActionCreators } from "../../../store/MainMenu/actionCreators";
import { default as audienceActionCreators } from "../../../store/UsersAndAudiences/Audiences/actionCreators";

import { MainTitle } from "../../../common/components/MainTitle";
import FormCustom, { ALL_DEPARTAMENTS } from "./components/FormCustom";
import { normalizeLseDepartmentId } from "./components/customAudienceDepartment";

class EditCustomAudienceContainer extends Component {
    componentDidMount() {
        const { setTitle, getOneCustomAudience, match } = this.props;
        setTitle("Audiences");
        getOneCustomAudience({ id: match.params.id });
    }

    componentWillUnmount() {
        const {
            clearTitle,
            clearOneCustomAudience,
            clearCustomAudienceLiveParamsStudents,
            clearCustomAudienceLiveParams,
        } = this.props;
        clearTitle();
        clearOneCustomAudience();
        clearCustomAudienceLiveParamsStudents();
        clearCustomAudienceLiveParams();
    }

    onSubmit = values => {
        if (values.studentsExcludedDeleteAll === true) {
            this.props.deleteExcludedFromCustomAudience(values.id);
        }

        this.props.putCustomAudience({
            id: values.id,
            lseDepartmentId: normalizeLseDepartmentId(values.lseDepartmentId),
            lseProgrammes: values.lseProgrammes
                ? values.lseProgrammes.map(i => {
                      return { id: i };
                  })
                : null,
            graduation: values.graduation,
            yearGroup:
                values.yearGroup !== "ALL"
                    ? Number(values.yearGroup) > 0
                        ? Number(values.yearGroup)
                        : null
                    : null,
            numStudents: values.numStudents,
            lseNumStudents: values.lseNumStudents,
            file: values.file ? values.file : null,
        });
    };

    render() {
        const {
            initialValues,
            history: { goBack },
        } = this.props;
        return (
            <div>
                <MainTitle title="Edit Custom Audience" />
                <FormCustom
                    currentFormType="EDIT"
                    onSubmit={this.onSubmit}
                    {...{
                        initialValues: {
                            ...initialValues,
                            lseDepartmentId:
                                initialValues.lseDepartmentId === null
                                    ? ALL_DEPARTAMENTS
                                    : initialValues.lseDepartmentId,
                        },
                        goBack,
                    }}
                />
            </div>
        );
    }
}

const dispatchToProps = {
    getOneCustomAudience: audienceActionCreators.getOneCustomAudience.create,
    clearOneCustomAudience: audienceActionCreators.clearOneCustomAudience.create,
    putCustomAudience: audienceActionCreators.putCustomAudience.create,
    deleteExcludedFromCustomAudience:
        audienceActionCreators.deleteExcludedFromCustomAudience.create,
    setTitle: mainMenuActionCreators.setTitle.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    clearCustomAudienceLiveParams: audienceActionCreators.clearCustomAudienceLiveParams.create,
    clearCustomAudienceLiveParamsStudents:
        audienceActionCreators.clearCustomAudienceLiveParamsStudents.create,
};

const mapStateToProps = ({ Audience }) => ({
    initialValues: Audience.customAudience
        ? {
              ...Audience.customAudience,
              lseProgrammes: Audience.customAudience.lseProgrammes
                  ? Audience.customAudience.lseProgrammes.map(p => p.id)
                  : Audience.customAudience.lseProgrammes,
          }
        : Audience.customAudience,
});

export default connect(mapStateToProps, dispatchToProps)(EditCustomAudienceContainer);
